import React, {useEffect, useState} from 'react';

// bootstrap
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';

// tremor
import { Title as TremorTitle, Subtitle, Text, Toggle, ToggleItem, Dropdown, DropdownItem, AreaChart, Metric, Flex, Bold, List, ListItem, TabList, Tab, Callout, BarChart} from '@tremor/react';

// custom components
import { CheckBox, AirportCheckBox } from '_atoms';

// styling
import { Colors, Spacing } from '_styles';

// icons
import { MdOutlineConnectingAirports } from "react-icons/md";

const AirportListSelector = (props) => {

    const [checkedAirports, setCheckedAirports] = useState([]);

    const airports = [
        'DUB', 'BRS', 'ORK', 'JFK'
    ];

    useEffect(() => {
        //console.log('countries', checkedCountries)
    }, [airports]);
    
    const handleAirportClick = (iata) => {
        if(checkedAirports.includes(iata)){
            checkedAirports.splice(checkedAirports.indexOf(iata), 1);
        } else {
            let temp = [...checkedAirports];
            setCheckedAirports([...temp, iata]);
        }
    }
      
    return (
        <Container>
            <Row>
                {/* Title + Select All Filter */}
                <Flex>
                    <Container className='mt-3'>
                        <MdOutlineConnectingAirports size={80} color={Colors.PRM_LIGHT_BLUE} />
                        <h4 className='mt-2'>Airport Availability</h4>
                        <Subtitle>Select the airports that your product is available in</Subtitle>
                    </Container>
                </Flex>
            </Row>
            
            <Container>
                <hr style={{ color:Colors.PRM_LIGHT_BLUE }} />
            </Container>

            <Row style={{ marginLeft:Spacing.SCALE_12 }}>
                <Row style={{ marginLeft:Spacing.SCALE_4, marginTop:Spacing.SCALE_4, padding:8 }}>
                { airports.map((iata, index) => {
                    return (
                        <AirportCheckBox iata={iata} onClick={handleAirportClick} checked={checkedAirports.includes(iata)} />
                    )
                })}
                </Row>
            </Row>

            <Container>
                <hr style={{ color:Colors.PRM_LIGHT_BLUE }} />
            </Container>

            <Container style={{ marginBottom:22  }}>
                <Flex>   
                    <Button onClick={props.cancel} variant={'outline-primary'}>Cancel</Button>
                    <Button onClick={()=>{props.done(checkedAirports)}} variant={'outline-primary'}>Done</Button>
                </Flex>
            </Container>

        </Container>
    );
};

export default AirportListSelector;
